import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';

/**
 * Phone-only sticky buy bar. Appears once the hero CTA has scrolled away
 * and steps aside while the pricing card is on screen.
 */
export function MobileBuyBar() {
  const [pastHero, setPastHero] = useState(false);
  const [pricingVisible, setPricingVisible] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    const pricing = document.getElementById('pricing');
    let observer: IntersectionObserver | undefined;
    if (pricing) {
      observer = new IntersectionObserver(([entry]) => setPricingVisible(entry.isIntersecting), {
        threshold: 0.15
      });
      observer.observe(pricing);
    }
    return () => {
      window.removeEventListener('scroll', onScroll);
      observer?.disconnect();
    };
  }, []);
  const visible = pastHero && !pricingVisible;
  return <AnimatePresence data-id="element-169" data-mp="3sj452i4md81z">
      {visible && <motion.div initial={reduceMotion ? {
      opacity: 0
    } : {
      y: '100%'
    }} animate={reduceMotion ? {
      opacity: 1
    } : {
      y: 0
    }} exit={reduceMotion ? {
      opacity: 0
    } : {
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-cream-dark bg-white/95 px-4 pt-3 pb-[max(12px,env(safe-area-inset-bottom))] backdrop-blur md:hidden" data-id="element-170" data-mp="3si2j3im2f15h">
          <div className="flex items-center" data-id="element-171" data-mp="3nk0z8vgtexsy">
            <a href="#pricing" className="flex min-h-[50px] flex-1 items-center justify-center whitespace-nowrap rounded-full border-b-4 border-gold-deep/40 bg-gold px-4 text-[16px] font-bold text-gold-ink transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-smoke/50" data-id="element-172" data-mp="3nksw09m5f1kt">
              Get all 72 sessions
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}